import { useQuery } from '@tanstack/vue-query'
import { computed, ref, watch } from 'vue'

import { explorerApi } from '~/api/client'
import type { NexonNftMintDetailInfo } from '~/api/repository'
import { latestMintKey } from '~/api/service/query-keys.const'

export const latestMintService = {
  useGetLatestMint: () => {
    const seqNo = ref<number | undefined>(undefined)
    const mintList = ref<NexonNftMintDetailInfo[]>([])

    const query = useQuery({
      queryKey: [ ...latestMintKey, seqNo ],
      queryFn: async () => {
        const res = await explorerApi.nexon.getLatestMint({
          requestBody: {
            seqNo: seqNo.value
          }
        })
        return res
      },
      refetchInterval: 2000
    })

    watch(() => query.data.value, (newData) => {
      if (newData) {
        mintList.value = [ newData as NexonNftMintDetailInfo ]
        seqNo.value = newData.SEQNO
      }
    }, { immediate: true })

    return {
      ...query,
      data: computed(() => mintList.value)
    }
  }
}   